import { render, staticRenderFns } from "./ShowcasePrices.vue?vue&type=template&id=c8173986&"
import script from "./ShowcasePrices.vue?vue&type=script&lang=js&"
export * from "./ShowcasePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports